module.exports = __webpack_public_path__ + "img/PIVX.c3eff78a.svg";